module.exports = require("axios");


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 15
// module chunks = 0